let reyManda = [
    'Confesá algo que no sepa nadie o toma un trago por cada participante que haya.',
    'Elegí a alguien para que tome por 7 segundos.',
    'Tomás vos solo.',
    'Toman los que tienen pareja.',
    'Iniciá un "tengo un barquito lleno de..."',
    'Toman los que estén usando tanga.',
    'Piedra, papel, tijera con el jugador a tu derecha. El que pierde toma 3 tragos.',
    'Tenés que estar agarrado de la mano con el jugador a tu izquierda por dos rondas.',
    'Contá lo más vergonzoso que te haya pasado o tomá 4 tragos.',
    'Toma el que tenga el vaso más lleno.',
    'Decí un trabalenguas. Si lo decís mal tenés que tomar, si lo decís bien toman todos menos vos.',
    'Formas de decirle al aparato genital femenino YA. El primero que pierda toma 4 tragos.',
    'Toman 2 tragos los que alguna vez hayan quebrado en alguien.',
    'Si hoy lavaste los platos elegís quien toma. Si no lo hiciste tomá 3 tragos.',
    'Vos y una persona que elijas tienen que tomar 2 shots de bebida blanca cada uno.',
    'Si le hablaste a tu ex hace menos de un mes tomá 4 tragos.',
    'Toman los que estén teñidos.',
    'Toman los que sean más bajitos que vos, si sos el más bajito toma un trago por cada jugador.',
    'Por dos rondas cada vez que te dejes de mover, los jugadores también tendrán que hacerlo. Toma el último que lo hace.',
    'Toma el de la nariz más chica.',
    'Cascada. Empezás vos.',
    'Toman los que no coman carne.',
    'Si dos personas o más de la habitación estuvieron juntas, tienen que tomar 3 tragos cada uno. Toman todos si nadie estuvo con nadie.',
    'Cada vez que hablas tenés que hacer una pausa entre palabra y palabra. Cada pausa que no haces vale por un trago.',
    'Cada jugador tiene que deletrear el nombre del jugador a su derecha. Toma por cada letra equivocada. Empezas vos.',
    'Toma el jugador con menos gira.',
    'No se pueden usar nombres propios por dos rondas.',
    'Si ayer estuviste en pedo tomás 3 tragos.',
    'Cada partido político que nombres es un trago que podes repartir.',
    'El último jugador que hace la pose de rodrigo toma 3 tragos.',
    'Tengo un barquito lleno de... sinónimos de "emborracharse".',
    'Comentá la primera foto que te aparezca en instagram o toma 5 tragos.',
    "La última persona que comió en McDonald's tiene que hacer 15 sentadillas. Si no lo hace toma 3 tragos.",
    'Mandale una selfie a la última persona con la que hablaste. Si no, tomá 4 tragos.',
    'Todos los jugadores deben dejar el celular en la mesa, el primero que lo agarre toma 4 tragos.',
    'Tiene que tomar 5 tragos el primer jugador al que le llegue una notificación en el celular. Empezando ahora.',
    'Toma sin usar las manos.',
    'Toman todos: tienen que tomar un trago por cada llave que tiene en el llavero.',
    'Toman los jugadores que nacieron en un año impar.',
    'Podés agregar, modificar o eliminar una regla.',
    'Podés agregar, modificar o eliminar una regla.',
    'Podés agregar, modificar o eliminar una regla.',
    'Tomá 2 tragos si estuviste hospitalizado este año.',
    'Competencia de pestañeo con el jugador a tu izquierda.',
    'Empezás diciendo "abro el baúl", una acción y "cierro el baúl. El jugador a tu izquierda dice "abro el baúl, tu acción, una acción y "cierro el baúl" y así... El primero en fallar toma 3 tragos.',
    'Contale un chiste a los jugadores. Toman los que se ríen. Si no se ríe nadie tomás 2 tragos.',
    'Contesta la primera historia que te aparezca en instagram o tomá 4 tragos.',
    'Tenés que fondear lo que estés tomando.',
    'Podés darle 4 tragos a las personas más altas que vos. Si sos la más alta toma 5.',
    'La última persona que cortó con su pareja toma 3 tragos.',
    'Tienen que hablar con acento italiano por una ronda.',
    'Tienen que hablar con acento mexicano por una ronda.',
    'Tienen que hablar con acento español por una ronda.',
    '¿A qué edad tuviste tu primer beso? Toma un trago por cada año.',
    'Toma el último que se levanta de la silla.',
    'Toma 2 tragos el primero que se levante de la silla.',
    'Toma 4 tragos el jugador que ponga pie de fotos filosóficos/de cornuda en instagram.',
    'Toman las personas más grandes que vos.',
    'Elegí un jugador para que fondee su vaso.',
    'Formas de decirle al aparato aparato reproductor masculino YA. El primero que pierda toma 4 tragos.',
    'Dígalo con mímica. Hace una película y si los jugadores la adivinan en 45 segundos, tomas. Si no, toman todos menos vos.',
    'Por 3 tragos: pulseadita china con el jugador a tu derecha.',
    'Toma 3 tragos el jugador que menos en pedo esté.',
    'Decile al jugador a tu izquierda dos mentiras y una verdad. Si no la adivina toma 3 tragos, si la adivina tomás 4 tragos.',
    'Decí los nombres de los padres del jugador a tu izquierda. Si no podes tomás 5 tragos.',
    '¿Qué día naciste? Tomá esa cantidad de tragos.',
    'Subí una encuesta en instagram: "sí o no". Tomás un trago por cada "sí".',
    'Toman todos menos vos.',
    'Tomás un trago por cada tatuaje que tengas.',
    'Tomás un trago por cada piercing que tengas.',
    'Elegí un jugador para que haga fondo con vos, el que gana puede decidir una regla o prenda para todos.',
    'Elegí a alguien. Por dos rondas esa persona tiene que tomar el doble de todo lo que vos tomes.',
    'Un trago por cada ex que tengas.',
    'Fondea el vaso. Si lo hacés podés elegir un jugador para que lo haga. Si ese jugador lo hace también puede elegir otro jugador para hacerlo, y así sucesivamente.',
    'Bailá "todo el mundo sabe que borracho se cae" mientras fondeas.',
    'Proponé un brindis.',
    'Toman todos los de tu mismo signo.',
    'Ni sí, ni no, ni blanco, ni negro. El primer jugador que diga "sí/no/blanco/negro", pierde.',
    'Programá una alarma para dentro de 5 minutos. Toma 4 tragos el jugador en el que cae.',
    'Decí tres de los peores chamuyos.',
    'Cada jugador tiene que decir una provincia. El que no puede o repite toma 4 tragos.',
    'Toman todos los que hayan vomitado en un auto en movimiento',
    'Nombrá tres ventajas de estar en la cárcel por dos años. Si no podés tomás 3 tragos.',
    'Nombrá tres cosas que puedas hacer en el agua. Si no podés tomás 3 tragos.',
    'Elegí un jugador para darle un trago. Los jugadores a su derecha e izquierda toman también.',
    'Toma el jugador que moriría primero en un apocalipsis zombie.',
    'Toma el jugador que probablemente se case con alguien que todavía no nació.',
    'Toma el jugador que peor maneja.',
    'Toma el jugador con menos ropa.',
    'Toma el jugador con más probabilidades de seguir viviendo con sus padres a los 45 años.',
    'Toma el jugador con más probabilidades de ganar la presidencia.',
    'Toma el jugador que moriría primero de sobredosis si todos fueran estrellas de rock.',
    'Toma el jugador que este en frente tuyo.',
    'Toma el jugador con más probabilidades de tomar una decisión en base a la posición de los planetas ese día.',
    'De ahora en más tu apodo será "lechuguita".',
    'Mandale un mensaje por instagram a alguien con quien nunca hayas hablado o toma 7 tragos.',
    'Todos los jugadores deben cerrar los ojos, a la cuenta de tres abrirlos y mirar a alguien. Toman los jugadores que estén haciendo contacto visual.',
    'Toman los pakis.',
    'Hacele un cumplido al jugador a tu derecha. El jugador a tu izquierda tiene que tomar 3 tragos.',
    'Por una ronda solo podés usar tu mano izquierda.',
    'Ponele un nuevo apodo al jugador a tu derecha.',
    'Toman los jugadores que estén tomando lo mismo que vos.',
    'Tómás 3 tragos si estuviste con alguno de los jugadores.',
    'A la cuenta de tres, los jugadores tienen que señalar un jugador. Toma 4 tragos el jugador con más dedos apuntándolo.',
    'Sacate una foto con el inodoro y subila a instagram. Si no lo haces toma 6 tragos.',
    'Elegís una palabra para que esté prohibida por dos rondas.',
    'Toman 3 tragos los que tengan el tick azul de WhatsApp oculto.',
    'Tomás un trago por cada hermano que tengas.',
    'Jugá una pulseada con el jugador a tu derecha. El que pierde toma 2 tragos.',
    'Toman 3 tragos los que hayan cagado a su ex.',
    'Toma el dueño de la casa.',
    'Solo te podés comunicar con ruidos de animales por una ronda.',
    'Tenés que hacer la vertical. Si no podés tomás 4 tragos.',
    'Tenés que actuar como si fueras el entrenador del jugador a tu derecha por 2 rondas.',
    'Por tres rondas cada vez que algún jugador diga "no" tiene que ser con voz finita.',
    'Tenés que repetir todo lo que diga el jugador a tu izquierda por una ronda.',
    'Todos los jugadores tienen que hablar como borrachos por una ronda.',
    'Por dos rondas tienen que terminar cada frase que digan con una risa malvada.',
    'Tenés que tratar como un bebé al jugador a tu izquierda por una ronda.',
    'El jugador a tu derecha y vos tienen que elegir un reto para el resto de los jugadores.',
    'Tenés que jugar bailando por una ronda.',
    'Señalá a otro jugador que a su vez tendrá que señalar a otro y así sucesivamente. Toma el jugador que quede sin señalar.',
    'Toman los que jueguen al LOL.',
    'Tenés que cantar la cucaracha pero cambiar todas las "A" por "E". Tomá un trago por cada error.',
    'Cada vez que tomen tienen que decir "ser flogger es como ser un rockstar" por dos rondas.',
    'Tenés que recrear la pelea de Mauro Viale y Samid con el jugador a tu izquierda.',
    'Cantá la canción de bokita. Se tienen que sumar todos los jugadores. El último que se suma toma 4 tragos.',
    'Sin repetir y sin soplar: frases de Ricardo Fort. Toma el primero que pierda.',
    'Sin repetir y sin soplar: frases de Los Simpsons. Toma el primero que pierda.',
    'Sin repetir y sin soplar: frases de Maradona. Toma el primero que pierda.',
    'Sin repetir y sin soplar: capítulos de "Los Simuladores". Toma el primero que pierda',
    'Empezando por vos: cada jugador tiene que decir el slogan de una marca. Toma el primero que pierda',
    'Empezando por vos: cantantes o bandas argentinas de cumbia. Toma el primero que pierda',
    'Tenés que subir un video a instagram imitando a Fer Palacio si no tomás 6 tragos',
    'Los jugadores tienen que ir diciendo los números en orden pero no pueden decir ni 3, ni múltiplos de 3, ni números que contengan 3. En su lugar tienen que decir "Pim", al siguiente "Pam", luego "Pum", después nuevamente "Pam" y así.',
    'Toman los jugadores que fuman.',
    'Tenés que comer una hoja y después gritar como Tarzan.',
    'Tenés que chuparle el ombligo a la persona que esté frente tuyo.',
    'Todos los que tengan algo rojo tienen que bailar la macarena.',
    'Todos toman la mitad de lo que tengan en el vaso.',
    'La última persona que se siente en el piso con las manos arriba toma 3 tragos.',
    'Tenés que cerrar los ojos y decir que tiene puesto la persona a tu derecha. Si no podes, tomás 3 tragos.',
    'Toman todos los que usen crocs.',
    'Tenés que adivinar lo que usa la persona a tu izquierda para dormir. Si no podés, tomás 3 tragos.',
    'Tenés que mandarle una foto a las últimas dos personas que hablaste por Instagram.',
    'Vos y la persona a tu derecha tienen que intentar meterse el puño entero en la boca. El que no pueda toma 3 tragos.',
    'Tenés que mostrar tu historial de Google.',
    'Tenés que subir una story a Instagram poniendo"Que sale hoy?".',
]

export default reyManda